import React, { useEffect, useCallback, useState, useMemo } from 'react';
import { useDispatch } from 'react-redux';

import { LinearProgress, Tab, Tabs, Box, Typography } from '@material-ui/core';
import PropTypes from 'prop-types';

import { t, number } from '~/helpers';
import api from '~/services/api';

import Grafico from '../Grafico';
import Tabela from '../Tabela';
import TabPanel from '../TabPanel';

// FunÃ§Ã£o auxiliar para propriedades de acessibilidade das abas
function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

export default function TabelaArqueacaoUpdate({
  data,
  close,
  sending,
  onForm,
}) {
  const dispatch = useDispatch();
  const [tabelaFinal, setTabelaFinal] = useState([]);
  const [intervalosJaArqueados, setIntervalosJaArqueados] = useState([]);
  const [intervalosCapturados, setIntervalosCapturados] = useState([]);
  const [intervaloAceito, setIntervaloAceito] = useState({});
  const [loading, setLoading] = useState(true);
  const [tabItem, setTabItem] = useState(0);
  const [info, setInfo] = useState(null);

  const cell = useMemo(
    () => [
      {
        id: 'alturaarqueacaoitem',
        label: t('s.relatorio.descarganf.altura'),
        align: 'right',
      },
      {
        id: 'volumeoriginalarqueacaoitemautomatica',
        label: t('s.operacao.recebimentonf.volatual'),
        align: 'right',
        format: (value) => number(value, 2),
      },
      {
        id: 'volumearqueacaoitem',
        label: t('s.operacao.arqueacaoautomatica.volajustado'),
        align: 'right',
        format: (value) => (value !== null ? number(value, 2) : value),
      },
      {
        id: 'diferenca',
        label: t('s.relatorio.alteracaoencerrante.diferenca'),
        align: 'right',
        format: (value) => (value !== null ? number(value, 2) : value),
      },
    ],
    []
  );

  useEffect(() => {
    if (!data || !data.idarqueacaoautomatica) {
      return;
    }

    const {
      alturamaximaarqueacao,
      alturamaximaarqueacaoautomatica,
      alturaminimaarqueacaoautomatica,
    } = data;

    if (
      alturamaximaarqueacao &&
      alturamaximaarqueacaoautomatica &&
      alturaminimaarqueacaoautomatica
    ) {
      setInfo({
        alturamaximaarqueacaoautomatica,
        alturaminimaarqueacaoautomatica,
        percentual:
          ((alturamaximaarqueacaoautomatica - alturaminimaarqueacaoautomatica) /
            alturamaximaarqueacao) *
          100,
      });
    } else {
      setInfo(null);
    }

    const fetchArqueacoes = async () => {
      setLoading(true);
      const response = await api.get(
        `arqueacaoautomatica/${data.idarqueacaoautomatica}`
      );

      const dados = response.data;

      const dtTabelaFinal = dados.tabelafinal.map((item) => {
        const diferenca =
          item.volumeoriginalarqueacaoitemautomatica - item.volumearqueacaoitem;
        return {
          ...item,
          diferenca,
        };
      });

      setIntervalosCapturados(dados.intervaloscapturados);
      setIntervalosJaArqueados(dados.intervalosjaarqueados);
      setTabelaFinal(dtTabelaFinal);
      setLoading(false);
    };
    fetchArqueacoes();
  }, [data]);

  useEffect(() => {
    if (info) {
      setIntervaloAceito({
        alturainicial: info.alturaminimaarqueacaoautomatica,
        alturafinal: info.alturamaximaarqueacaoautomatica,
      });
    }
  }, [info]);

  const handleTabChange = useCallback((event, newValue) => {
    setTabItem(newValue);
  }, []);

  return (
    <>
      {loading && <LinearProgress />}
      <Box sx={{ borderBottom: 1, borderColor: '#3f51b5' }}>
        <Tabs
          value={tabItem}
          onChange={handleTabChange}
          aria-label="basic tabs example"
        >
          <Tab label={t('Gráfico')} {...a11yProps(0)} />
          <Tab label={t('Tabela')} {...a11yProps(1)} />
        </Tabs>
      </Box>

      <TabPanel value={tabItem} index={0}>
        <Grafico
          data={tabelaFinal}
          intervalosJaArqueados={intervalosJaArqueados}
          intervalosCapturados={intervalosCapturados}
          intervaloAceito={intervaloAceito}
        />
      </TabPanel>

      <TabPanel value={tabItem} index={1}>
        <Tabela cells={cell} data={tabelaFinal} size="small" height="100%" />
      </TabPanel>
    </>
  );
}

TabelaArqueacaoUpdate.propTypes = {
  data: PropTypes.objectOf(
    PropTypes.oneOfType([PropTypes.number, PropTypes.object])
  ).isRequired,
  close: PropTypes.func.isRequired,
  sending: PropTypes.bool.isRequired,
  onForm: PropTypes.func.isRequired,
};
